export enum MediaType {
    List = 'list',
    Page = 'page',
    Rss = 'rss',
    Contact = 'contact',
    Web = 'web',
    Image = 'image',
    File = 'file',
    Video = 'video',
    NotAccepted = 'notAccepted',
    Audio = 'audio',
    Form = 'form'
}

export interface IMediaItem {
    mediaType: MediaType
    contentType: string,
    url: string,
    description: string,
    fileName: string,
    thumbnail: {
        url: string,
        contentType: string
    }
}

export interface IContentImagePreviewPanel { 
    className?: string, 
    mediaItems: IMediaItem[], 
    maxVisible: number, 
    totalMediaItems: number
}

export interface IContentOrderSetter {
    content: IContentTile[];
    setContent: (content: IContentTile[]) => void;
}

export interface IContentTile {
    id: number,
    title: string,
	featuredImageAssetId: number,
	featuredImageUrl: string
}

export interface IContentListItem {
    item: { id: number, title: string };
    index: number;
    moveItem: (from: number, to: number) => void;
    onMoveUp: () => void;
    onMoveDown: () => void;
    isFirst: boolean;
    isLast: boolean;
}